module.exports = __webpack_public_path__ + "static/media/flatbed-truck-cropped.5b2f61ed.svg";